import { YN_TYPE_WITH_EMPTY } from '../common/common-models';

export class PtnrEntity {
  ptnrId: number = 0;
  crmPtnrId: string = '';
  accountId: string = '';
  lang: string = '';
  ptnrName: string = '';
  ptnrDesc: string = '';
  contactName: string = '';
  sequence: number = 0;
  ptnrYn: YN_TYPE_WITH_EMPTY = '';
  contactUserId: string = '';
  phoneNumber: string = '';
  ptnrAdminUserId: string = '';
}

// export class IValidPtnrName {
//   partnerName: boolean = false;
//   checkPartnerName: boolean = false;
// }

export interface IfPtnr extends PtnrEntity {}

export const emptyPtnrList: IfPtnr = new PtnrEntity();

export class IChangePtnrSeq {
  ptnrId: number;
  ptnrSequence: number;
  targetPtnrId: number;
  targetSequence: number;
}

export class PtnrContact {
  contactId: string = '';
  name: string = '';
  email: string = '';
  mobilePhone: string = '';
}

export interface IfPtnrContact extends PtnrContact {}
